/** CSV encode a value. Wraps in quotes + escapes inner quotes if needed. */
function csvCell(v: any): string {
  if (v === null || v === undefined) return "";
  let s: string;
  if (v instanceof Date) s = v.toISOString();
  else if (typeof v === "object") s = JSON.stringify(v);
  else s = String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export interface CsvColumn<T> {
  key: string;
  label: string;
  /** Optional accessor — default is the key. Useful for nested fields. */
  get?: (row: T) => any;
}

export function exportCSV<T extends Record<string, any>>(
  filename: string,
  rows: T[],
  columns: CsvColumn<T>[],
) {
  const header = columns.map((c) => csvCell(c.label)).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((c) => csvCell(c.get ? c.get(row) : row[c.key]))
        .join(","),
    )
    .join("\n");
  const blob = new Blob([header + "\n" + body], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
